import { render, staticRenderFns } from "./kdQeEnsurePermanentSolutionAudit.vue?vue&type=template&id=821a43c0&scoped=true"
import script from "./kdQeEnsurePermanentSolutionAudit.vue?vue&type=script&setup=true&lang=js"
export * from "./kdQeEnsurePermanentSolutionAudit.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821a43c0",
  null
  
)

export default component.exports